import script from "./deliOnceImg5.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg5.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg5.vue?vue&type=style&index=0&id=3d190f03&lang=less"

const __exports__ = script;

export default __exports__